// File for logic corresponding to article-list-carousel component
import { Component } from 'js-component-framework';
import Debounce from 'utils/Debounce';
import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import './article-list-carousel.scss';

/**
 * Component for article-list-carousel
 */
export default class ArticleListCarousel extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    const { context, carouselDuration } = this.element.dataset;

    if ('carousel_sidebar' === context) {
      this.fixArrowsPosition = this.fixArrowsPosition.bind(this);

      if (carouselDuration && '0' !== carouselDuration) {
        // Set the autoplay speed from Widget settings.
        this.options.slickOptionsSidebar.autoplaySpeed = carouselDuration;
        this.options.slickOptionsSidebar.autoplay = true;
      }

      $(this.children.articleContent).slick(this.options.slickOptionsSidebar);
      this.fixArrowsPosition();
    } else if ('carousel_dropin' === context) {
      this.shouldUpdateLayout = this.shouldUpdateLayout.bind(this);
      this.setArticlesLayout = this.setArticlesLayout.bind(this);

      this.onResizeDebounce = new Debounce(
        this.shouldUpdateLayout,
        'resize',
        window,
        250,
        false,
      );

      this.shouldUpdateLayout();
    } else if ('external_image_gallery' === context) {
      this.updateEnlargedImg = this.updateEnlargedImg.bind(this);
      const { slickOptionsImageGallery } = this.options;
      const { articleContent, articles } = this.children;

      $(articleContent).slick(slickOptionsImageGallery);

      Array.prototype.forEach.call(articles, (article) => {
        article.addEventListener('click', this.updateEnlargedImg);
      });
    }
  }

  /**
   * Set carousel articles layout class.
   * @param {string} oldClass  class to be removed from article.
   * @param {string} newClass  class to be added from article.
   */
  setArticlesLayout(oldClass, newClass) {
    const { articles } = this.children;

    if (! articles) {
      return;
    }

    articles.forEach((article) => {
      if (article.classList.contains(oldClass)) {
        article.classList.remove(oldClass);
        article.classList.add(newClass);
      }
    });
  }

  /**
   * Determine if we are displaying carousel or non-carousel layout
   */
  shouldUpdateLayout() {
    const { articleContent } = this.children;
    const {
      stackedClass,
      slatClass,
      slickOptions,
    } = this.options;

    if (! articleContent.classList.contains('slick-initialized')) {
      $(articleContent).slick(slickOptions);
      this.setArticlesLayout(slatClass, stackedClass);
    }
  }

  /**
   * Fix the arrows position when `appendArrows` slick option is set to a
   * element within 'slick-slider'
   *
   * @link https://github.com/kenwheeler/slick/issues/3657
   * @see `slickOptionsSidebar`
   */
  fixArrowsPosition() {
    const { articleContent } = this.children;

    // Add position relative to image thumb wrapper.
    $(articleContent)
      .find('.article-list__article-thumb')
      .css('position', 'relative');

    // Rebind click handler for navigation.
    $(articleContent)
      .find('.slick-prev')
      .on('click', () => {
        $(articleContent).slick('slickPrev');
      });

    $(articleContent)
      .find('.slick-next')
      .on('click', () => {
        $(articleContent).slick('slickNext');
      });
  }

  /**
   * Update enlarged image src and alt attributes with currentTarget data
   * attributes.
   *
   * @param {object} event the event object.
   */
  updateEnlargedImg(event) {
    const { enlargedThumb } = this.children;
    const { imgUrl, imgAlt } = event.currentTarget.dataset;
    const hasImgUrl = 'imgUrl' in event.currentTarget.dataset;
    const hasImgAlt = 'imgAlt' in event.currentTarget.dataset;

    if (! enlargedThumb && ! hasImgUrl && ! hasImgAlt) {
      return;
    }

    enlargedThumb.setAttribute('src', imgUrl);
    enlargedThumb.setAttribute('alt', imgAlt);
    enlargedThumb.setAttribute('srcset', event.currentTarget
      .querySelector('div img').getAttribute('srcset'));
    enlargedThumb.setAttribute('sizes', event.currentTarget
      .querySelector('div img').getAttribute('sizes'));
  }
}
